(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  connectedCallback(){
    this.header=this.closest('.shopify-section')||this;
    this.always=this.getAttribute('data-sticky-type')==='always'||this.getAttribute('data-sticky-type')==='reduce-logo-size';
    this.bounds={bottom:0,top:0};this.current=0;
    document.documentElement.style.setProperty('--header-height',`${this.offsetHeight}px`);
    new IntersectionObserver((e,o)=>{this.bounds=e[0].intersectionRect;o.disconnect()}).observe(this);
    this._onScroll=this.onScroll.bind(this);window.addEventListener('scroll',this._onScroll,false);
    if(this.always&&this.header)this.header.classList.add('shopify-section-header-sticky');
  }
  disconnectedCallback(){window.removeEventListener('scroll',this._onScroll)}
  onScroll(){const y=window.pageYOffset||document.documentElement.scrollTop;if(!this.header)return;if(this.always){this.current=y;return}if(y>this.current&&y>this.bounds.bottom){this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky')}else if(y<this.current&&y>this.bounds.bottom){this.header.classList.add('shopify-section-header-sticky','animate');this.header.classList.remove('shopify-section-header-hidden')}else if(y<=this.bounds.top){this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate')}this.current=y}
}
if(!customElements.get('sticky-header'))customElements.define('sticky-header',StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
